import { describeFields, FieldWidget, getEnumOptions } from '../common/fields';
import { MfaMethod } from './enums';
import { MfaMethodSchema, UserStatusSchema } from './schemas';

export const USER_STATUS_FIELDS = describeFields(UserStatusSchema, {
  enabled: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  accountStatus: {},
  // MFA is always on, so a form offers no way to turn it off
  mfaMethod: {
    options: getEnumOptions(MfaMethodSchema).filter(option => option.value !== MfaMethod.None),
  },
  temporaryPassword: {},
});
